const PLATE_HISTORY_KEY = 'plate_history'

export interface PlateHistoryItem {
  plate: string
  timestamp: number
}

export const plateHistoryUtils = {
  getPlateHistory(): PlateHistoryItem[] {
    try {
      const stored = localStorage.getItem(PLATE_HISTORY_KEY)
      return stored ? JSON.parse(stored) : []
    } catch (error) {
      console.error('Erro ao ler histórico de placas:', error)
      return []
    }
  },

  addPlateToHistory(plate: string): void {
    try {
      const history = this.getPlateHistory()
      const newItem: PlateHistoryItem = {
        plate: plate.toUpperCase(),
        timestamp: Date.now(),
      }

      const filteredHistory = history.filter((item) => item.plate !== newItem.plate)
      const updatedHistory = [newItem, ...filteredHistory]
      const limitedHistory = updatedHistory.slice(0, 3)

      localStorage.setItem(PLATE_HISTORY_KEY, JSON.stringify(limitedHistory))
    } catch (error) {
      console.error('Erro ao salvar placa no histórico:', error)
    }
  },

  removePlateFromHistory(plate: string): void {
    try {
      const history = this.getPlateHistory()
      const filteredHistory = history.filter((item) => item.plate !== plate.toUpperCase())
      localStorage.setItem(PLATE_HISTORY_KEY, JSON.stringify(filteredHistory))
    } catch (error) {
      console.error('Erro ao remover placa do histórico:', error)
    }
  },

  clearPlateHistory(): void {
    try {
      localStorage.removeItem(PLATE_HISTORY_KEY)
    } catch (error) {
      console.error('Erro ao limpar histórico de placas:', error)
    }
  },
}
